// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__15shb","errorLogs":"EditorFooter_errorLogs__G8rxr"};